AboutCtrl.$inject = ["$scope", "CONSTANTS"];
export default function AboutCtrl($scope, CONSTANTS) {
  $scope.message = CONSTANTS.appName;
}
